import { Injectable, NgZone, Optional } from '@angular/core';
import { InterfaceService } from '@app/interfaces';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import {Subject} from "rxjs/internal/Subject";
import {map, tap} from 'rxjs/operators';
import {BsModalRef} from "ngx-bootstrap";
import {JobHoldAbortFocComponent} from "@app/shared/cs-components/common-jobs/job-hold-abort-foc/job-hold-abort-foc.component";
import {ConfirmModalConfig, WarningModalConfig} from "@app/interfaces/common-modal-popups";
import {JobFocAndAbortComponent} from "@app/shared/cs-components/common-jobs/free-of-charge-and-abort/job-foc-and-abort.component";
import {SidepanelModalService} from "@app/sidepanel/services/sidepanel-modal.service";
import {GetV5CoreApiUrl} from "@app/utils/get-v5-core-api-url";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {JobSidebarService} from "@app/job-sidebar/job-sidebar-service";

export interface GetPartsIdsResponse {
    partIds: number[];
    data: any[];
    count: number;
}

@Injectable({ providedIn: 'root' })

export class JobViewService extends InterfaceService {

    private jobReasonsData =[];
    private timelineTriggerEvent = new Subject<void>();
    timelineTriggerEvent$ = this.timelineTriggerEvent.asObservable();

    private recallDetails = new Subject<void>();
    recallDetails$ = this.recallDetails.asObservable();

    removeOnHoldConfirm = (arg, cb) =>{
        let  removejobonhold = {
            removejobonhold :{
                id:this.jobReasonsData['jobId']
            }
        };
        this.removeOnHold(removejobonhold).subscribe(res => {
            cb();
            this.ngZone.run(() => this.timelineTriggerFunction(res));
            const jid = this.jobReasonsData['jobId'];
            if (jid != null) {
                this.jobSidebarService.notifyJobDetailsRefresh(jid);
            }
        }, err => {
            cb();
        });

    }
    private confirmModalConfig = {
        showModal: false,
        modalType: 'confirm',
        title: 'Remove on hold',
        actionText: 'remove',
        itemText: 'on-hold status from this job',
        confirmBtnText: 'Remove',
        confirmBtnType: 'DELETE',
        confirmBxValidationMsg: 'You need to type the word \'REMOVE\' to remove the on-hold',
        defaultTextMessage: true,
        message: {
            warningTxt: 'By removing job from the on-hold status you understand the job will appear as a normal outstanding job and will need further action i.e. rebook/invoicing etc.',
        },
        doAction: this.removeOnHoldConfirm
    };

    deleteJobConfirm = (arg, cb)=>{
        let  deleteJob = {
            job :{
                id:this.jobReasonsData['jobId']
            }
        };
        this.deleteJob(deleteJob).subscribe(res => {
            cb();
            this.timelineTriggerFunction(res);
            this.router.navigateByUrl('/customers/' + this.jobReasonsData['customerType'] + '/' +this.jobReasonsData['customerId'] + '/view_v2/property/view');
        }, err => {
            cb();
            this.timelineTriggerFunction('res');
            this.router.navigateByUrl('/customers/' + this.jobReasonsData['customerType'] + '/' +this.jobReasonsData['customerId'] + '/view_v2/property/view');
        });
    }
    private deleteConfirmModalConfig = {
        showModal: false,
        modalType: 'confirm',
        title: 'Delete job',
        actionText: 'delete',
        confirmBtnText: 'delete',
        closeText: 'Close',
        confirmBtnType: 'DELETE',
        itemText: 'job',
        confirmBxValidationMsg: 'You need to type the word \'DELETE\' to remove the job',
        defaultTextMessage: false,
        message: {
            warningTxt: 'To confirm you wish to delete this job, please type DELETE in the box below and click delete.',
        },
        doAction: this.deleteJobConfirm,
    };

    setJobReasonsData(data: any) {
        this.jobReasonsData = data;
    }
    getRemoveOnHoldData(){
       return  this.confirmModalConfig;
    }
    getDeleteConfirmModalData(){
        return  this.deleteConfirmModalConfig;
    }

    constructor(private http: HttpClient,
                private modalService: SidepanelModalService,
                private bsModalRef: BsModalRef,
                private router: Router,
                private translate: TranslateService,
                private ngZone: NgZone,
                private jobSidebarService: JobSidebarService
    ) {
        super();
    }

    private triggerFinanceRefresh(jobId?: number) {
        if (jobId != null && !isNaN(jobId)) {
            this.jobSidebarService.notifyJobFinanceRefresh(jobId);
        }
    }

    /** Row / save payloads may use jobId or jobid; missing id skips finance refresh. */
    private getJobIdFromPartPayload(payload: any): number | undefined {
        if (!payload) {
            return undefined;
        }
        const raw = payload.jobId != null ? payload.jobId : payload.jobid;
        if (raw === undefined || raw === null || raw === '') {
            return undefined;
        }
        const n = Number(raw);
        return !isNaN(n) ? n : undefined;
    }

    /** delete_part / remove_invoice_items / cost deletes often use FormData with jobId. */
    private getJobIdFromFormDataOrObject(payload: any): number | undefined {
        if (!payload) {
            return undefined;
        }
        if (typeof FormData !== 'undefined' && payload instanceof FormData) {
            const v = payload.get('jobId') || payload.get('jobid');
            if (v == null || v === '' || typeof v !== 'string') {
                return undefined;
            }
            const n = Number(v);
            return !isNaN(n) ? n : undefined;
        }
        return this.getJobIdFromPartPayload(payload);
    }

    getTimelineViewDetails(customerId,jobId) {
        let url = this.getApiUrl(`timelineViewDetails/${customerId}?tableType=31&id=${jobId}`);
        return this.http.get(url);
    }

    deleteAttachFiles(attachfile) {
        return this.http.post(this.getApiUrl(`delete_job_files`), attachfile);
    }

    getDairyList(customerId, jobId , customerType, param) {
        let url = this.getJobApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/diaryevents`);
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    }

    getCertificateList(customerId, jobId , param) {
        let url = this.getJobApiUrl((`customers/customer/${customerId}/job/${jobId}/certificates/view`));
        //return this.http.post(url, param);
        const certiData = this.http.post<any>(url, param).pipe(
            map(response => {
                return {
                    data: response.data || [],
                    count: response.count || 0,
                    addOnData: {
                        totalCount: response.count || 0,
                        params: param,
                        emailSubject: (response.addOnData && response.addOnData.emailSubject) ? response.addOnData.emailSubject : '',
                        emailMessage: (response.addOnData && response.addOnData.emailMessage) ? response.addOnData.emailMessage : ''
                    }
                };
            })
        );
        return certiData;
    }


    getJobViewDetails = function (id, type, jobId) {
        return this.http.get(this.getJobApiUrl(`customers/${type}/${id}/jobs/${jobId}/view`));
    };

    getJobCertificates = function (id, type, jobId) {
        return this.http.get(this.getJobApiUrl(`customers/${type}/${id}/job/${jobId}/certificates/view`));
    };

    deleteCertificate(id): Observable<any> {
        const formData = new FormData();
        formData.append("id",id );
        let url = this.getJobApiUrl((`delete_job_certificate`));
        return this.http.post(url, formData);
    }

    getJDArriveLeaveTemplatesList(type, jobDescriptionId): Observable<any> {
        return this.http.get(this.getJobApiUrl(`getJDArriveLeaveTemplatesList/${jobDescriptionId}/${type}`));
    }

    deleteDairy(id): Observable<any> {
        return this.http.delete(this.getApiUrl(`delete_diary_event/${id}`));
    }

    getCreatedByTypeTemplatesList(): Observable<any> {
        return this.http.get(this.getJobApiUrl(`getCreatedByTypeList`));
    }

    updateFile(id: any, data: any) {
        return this.http.post(this.getJobApiUrl('e5ec7051/renameFile'), data);
    }

    getFileList(customerId, jobId , param) {
       // let url = this.getV5CoreApiUrl(`customers/customer/${customerId}/jobs/${jobId}/files/view`);
        let url = this.getJobApiUrl('e5ec7051/fileList');

        const fileData = this.http.post<any>(url, param).pipe(
            map(response => {
                return {
                    data: response.attached_files.data || [],
                    count: response.count || 0,
                    addOnData: { tags : response.attached_files.tags, filesCount: response.count || 0, params: param}
                };
            })
        );
        return fileData;
    }

    deleteJobFile(params: any) {
        return this.http.post(this.getJobApiUrl(`e5ec7051/deleteAttachedFile`), params, {
            responseType: 'text'
        });

    }

    downloadJobFilesZip(customerType: string, customerId: number, jobId: number, fileIds?: number[]): Observable<Blob> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/files/download-zip`);
        const body = fileIds && fileIds.length > 0 ? { fileIds } : {};
        return this.http.post(url, body, { responseType: 'blob' });
    }

    /** Download a single file via backend – file downloads instead of opening in browser. Backend expects fileIds array. */
    downloadJobFile(customerType: string, customerId: number, jobId: number, fileId: number): Observable<Blob> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/files/download`);
        return this.http.post(url, { fileIds: [fileId] }, { responseType: 'blob' });
    }

    saveOnHold = function(type,id,jobId,data){
        return this.http.post(this.getApiUrl(`customers/${type}/${id}/jobs/${jobId}/place_on_hold`), data);
    }
    removeOnHold = function (jobData){
        return this.http.post(this.getApiUrl(`remove_job_on_hold`), jobData);
    }
    freeOfCharge = function (type,id,jobId,data){
        return this.http.post(this.getApiUrl(`customers/${type}/${id}/jobs/${jobId}/free_of_charge_job`), data);
    }
    abortJob = function (type,id,jobId,data){
        return this.http.post(this.getApiUrl(`customers/${type}/${id}/jobs/${jobId}/new_abort_job`), data);
    }
    deleteJob = function (data){
        return this.http.post(this.getApiUrl(`delete_job`), data);
    }
    isJobDelete(id: number, jobId: number): Observable<any> {
        return this.http.get(this.getApiUrl(`is_job_delete?id=${id}&jobId=${jobId}`));
    }

    openSidePanel(type){
        let title = (type == 'foc') ? 'Free of charge this job' : 'Abort this job';
        let reasons = this.jobReasonsData[type];
        let label = (type == 'foc') ? 'Free of charge reason' : 'Abort reason';

        const initialState = {
            title: title,
            reasons: reasons,
            labelType: label,
        };
        this.bsModalRef = this.modalService.show(JobFocAndAbortComponent, {
            initialState: initialState
        });

        this.bsModalRef.content.onClose.subscribe(result => {
            if(result){
                let payload = {
                    freeofchargeandabortjob: {
                        reason: result['reason'],
                        moredetails: result['note'],
                        JobView: false
                    }
                };
                if(type == 'foc'){
                    this.freeOfCharge(this.jobReasonsData['customerType'],this.jobReasonsData['customerId'], this.jobReasonsData['jobId'],payload).subscribe(resp => {
                        this.timelineTriggerFunction(resp);
                        const jobId = this.jobReasonsData['jobId'];
                        if (jobId != null) {
                            this.jobSidebarService.notifyJobDetailsRefresh(jobId);
                        }
                    }, error => {
                        console.log('err', error);
                    });
                }else {
                    this.abortJob(this.jobReasonsData['customerType'],this.jobReasonsData['customerId'], this.jobReasonsData['jobId'],payload).subscribe(resp => {
                        this.timelineTriggerFunction(resp);
                        const jobId = this.jobReasonsData['jobId'];
                        if (jobId != null) {
                            this.jobSidebarService.notifyJobDetailsRefresh(jobId);
                        }
                    }, error => {
                        console.log('err', error);
                    });
                }

            }
        });

    }
    timelineTriggerFunction(res) {
        this.timelineTriggerEvent.next(res);
    }

    jobStatusChange(type: any) {

        const initialState = {
            title: 'Put job on hold',
            reasons: this.jobReasonsData[type],
            labelType: this.translate.instant('On.Hold.Description'),
            users:this.jobReasonsData['users'],
        };
        this.bsModalRef = this.modalService.show(JobHoldAbortFocComponent, {
            initialState: initialState
        });
        this.bsModalRef.content.onClose.subscribe(result => {
            if(result){
                let payload = {
                    onholdjob: {
                        settingsjobonholddescriptionid: result['reason'],
                        onholdjobusers: { onholdjobusers: '' },
                        jobView: false
                    }
                };
                this.saveOnHoldTrigger(payload);
            }
        });

    }
    saveOnHoldTrigger(payload){
        const jobId = this.jobReasonsData['jobId'];
        this.saveOnHold(this.jobReasonsData['customerType'],this.jobReasonsData['customerId'], jobId,payload)
            .subscribe(resp => {
                this.ngZone.run(() => this.timelineTriggerFunction(resp));
                if (jobId != null) {
                    this.jobSidebarService.notifyJobDetailsRefresh(jobId);
                }
            }, error => {
                console.log('err', error);
            });
    }

    getJobOpportunities = function (id, jobId, param) {
       let url =this.getJobApiUrl(`customers/customer/${id}/job/${jobId}/opportunities/view`);
        return this.http.post(url, param);
    };

    getJobOpportunitiesProposal(id: string, jobId: string): Observable<any> {
        const url = this.getJobApiUrl(`customers/customer/${id}/job/${jobId}/opportunities/proposal`);
        return this.http.post(url, '');
    }


    getJobOpportunitiesStage = function (id, jobId) {
        const formData = new FormData();
        formData.append("id",id );
        formData.append("jobId",jobId );
        let url = this.getJobApiUrl(`getJobOpportunityStages`);
        return this.http.post(url, formData);
    };

    getAttachmentTags = function () {
        let url = this.getJobApiUrl('/e5ec7051/fileList');
        return this.http.post(url,'');
    };

    checkClientDiskSpace(totalFileSize): Observable<any> {
        const formData = new FormData();
        formData.append("totalFileSize",totalFileSize );
        let url = this.getJobApiUrl(`/e5ec7051/check_client_storage_limit`);
        return this.http.post(url, formData);
    }

    linkRecallJob(formData): Observable<any> {
        let url = this.getJobApiUrl(`link_job`);
        return this.http.post(url, formData);
    }

    recallEvent(res) {
        this.recallDetails.next(res);
    }

    getInvoiceList(customerId, jobId, customerType, param, selectedType='') {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/invoices/revenue/${selectedType}/view`));
        const invoiceData = this.http.post<any>(url, param).pipe(
            map(response => {
                return {
                    data: response.data.invoices || [],
                    count: response.count || 0,
                    addOnData: response.addOnData
                };
            })
        );
        return invoiceData;
    }

    getInvoiceWipList = function (customerId, jobId, customerType, param,selectedType='' ) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/invoices/wip/${selectedType}/view`));
        return this.http.post(url, param);
    };

    /** WIP service pricing catalogue IDs not yet invoiced — for get_pricing_items excludePricingItems when adding a service */
    getWipExcludePricingItemIds(customerType: string, customerId: number, jobId: number) {
        const url = this.getJobApiUrl(
            `customers/${customerType}/${customerId}/job/${jobId}/invoices/wip/services/exclude-pricing-item-ids`
        );
        return this.http.get<{ excludePricingItemIds: number[] }>(url);
    }

    remove_invoice_items = function (param) {
        return this.http.post(this.getJobApiUrl(`remove_invoice_items`), param).pipe(
            tap(() => this.triggerFinanceRefresh(this.getJobIdFromFormDataOrObject(param)))
        );
    }

    delete_part = function (param) {
    return this.http.post(this.getJobApiUrl(`delete_part`), param).pipe(
        tap(() => this.triggerFinanceRefresh(this.getJobIdFromFormDataOrObject(param)))
    );
    }

    delete_supplier_invoice = function (id,invoiceId,param){
        let url = this.getApiUrl((`suppliers/${id}/invoice/${invoiceId}/delete`));
        return this.http.post(url, param).pipe(
            tap(() => this.triggerFinanceRefresh(this.getJobIdFromFormDataOrObject(param)))
        );
    }

    delete_credit_note = function (id,invoiceId,param){
        let url = this.getApiUrl((`suppliers/delete_credit_note`));
        return this.http.post(url, param).pipe(
            tap(() => this.triggerFinanceRefresh(this.getJobIdFromFormDataOrObject(param)))
        );
    }
    markCreditNoteNotRequired = function (param) {
        return this.http.post(this.getApiUrl(`mark_credit_note_not_required`), param).pipe(
            tap(() => this.triggerFinanceRefresh(this.getJobIdFromFormDataOrObject(param)))
        );
    }

    getPinnedNotesList(tablePKId): Observable<any> {
        return this.http.get(this.getJobApiUrl(`pinned_notes/${tablePKId}/view`));
    }

    getCostScheduledLabourList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/forecasted/scheduled_labour`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostRequestedPartsList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/forecasted/requested_parts`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostMaterialsInstalledList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/parts`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostCreditNotesList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/credit_notes`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostPartsReturnsList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/parts_returns`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostPurchaseOrderList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/forecasted/purchase_orders`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostSupplierInvoiceList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/supplier_invoices`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getCostDetails(customerId, jobId, customerType): Observable<any> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/costs/details`);
        return this.http.post(url, '');
    }

    getInvoiceDetails(customerId, jobId, customerType): Observable<any> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/invoices/details`);
        return this.http.post(url, '');
    }

    saveCustomColumn(screenName, param): Observable<any> {
        let data = { 'columnValue': param, 'screenName': screenName }
        let url = this.getApiUrl(`userColumnOrder`);
        return this.http.post(url, data);
    }

    getJobCertificateDetails(customerId, jobId, customerType): Observable<any> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/job_certificate_details`);
        return this.http.post(url, '');
    }


    customColumn(headers, gridConfig) {
        const headerSettings = headers;
        // 1. Filter only active headers
        // const activeHeaders = headerSettings.filter(h => h.active);
        let updatedColDefs = gridConfig.gridConfig.colDefs.map(col => {
            const headerInfo = headerSettings.find(h => h.field === col.field);
            if (headerInfo) {
                return {
                    ...col,
                    headerName: headerInfo.title || col.headerName,
                    hide: !headerInfo.active || headerInfo.hidden,
                    pos: headerInfo.pos
                } as any;
            }
            return col;
        });

        // 2. Sort based on pos
        updatedColDefs = updatedColDefs.sort((a, b) => {
            const posA = (a as any).pos !== undefined ? (a as any).pos : 9999;
            const posB = (b as any).pos !== undefined ? (b as any).pos : 9999;
            return posA - posB;
        });

        // 3. Remove temp pos property (optional)
        updatedColDefs = updatedColDefs.map(({ pos, ...rest }) => rest);

        // 4. Assign to gridConfig
        gridConfig.gridConfig.colDefs = updatedColDefs;
    }

    getPartsList (customerType, customerId, jobId, category, partStatus, param) {
         let url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/parts`);

         const partData = this.http.post<any>(url, param).pipe(
            map(response => {
                return {
                    data: response[category].data || [],
                    count: response[category].count || 0,
                    addOnData: {
                        active_columns: response[category].active_columns,
                        all_columns: response[category].all_columns,
                        column_formats: response[category].column_formats,
                        statusCount: response[category].statusCount,
                        moduleId: response['moduleId'],
                        jobToDos: response['jobToDos'],
                        groupKeys : param['groupKeys'] || [],
                        groupRowCount : response[category].count || 0,
                        data: response[category].data || [],
                    }
                };
            })
        );
        return partData;
    }

    /**
     * Get part IDs (and minimal row data) for current filters. Used when "Select All" is checked
     * with grouping so one API call can drive Delete, Fulfill, and Mark-as actions.
     */
    getPartsIds(customerType: string, customerId: number, jobId: number, params: {
        category: string;
        status: string;
        searchText?: string;
        filters?: any;
        milestoneval?: number | null;
        [key: string]: any;
    }): Observable<GetPartsIdsResponse> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/parts/ids`);
        const body = {
            category: params.category,
            status: params.status,
            searchText: params.searchText || '',
            milestoneval: params.milestoneval != null ? params.milestoneval : null,
            page: params.page != null ? params.page : 1,
            limit: params.limit != null ? params.limit : 10,
            ...params,
            rowGroupCols: null,
            groupKeys: null,
        };
        return this.http.post<any>(url, body).pipe(
            map(res => {
                const out = {
                    partIds: res.partIds || [],
                    data: res.data || [],
                    count: res.count != null ? res.count : (res.data || []).length,
                };
                return out;
            })
        );
    }
    getPartsDownloadList (customerType, customerId, jobId, param):Observable<any> {
        let url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/job_parts_download`);
        return this.http.post(url, param, {responseType: 'blob'});
    }

    getPartsDetails(customerId, jobId, customerType): Observable<any> {
        const url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/parts/details`);
        return this.http.post(url, '');
    }
    addJobPart(data,customerType:string,customerId:number,jobId:number):Observable<any>{
        let url = this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/add_new_part`);
        let newData = { 'part': data};
        return this.http.post(url, newData).pipe(
            tap(() => this.triggerFinanceRefresh(jobId))
        );
    }
    getPartDetails(jobId: number, partId: number): Observable<any> {
        const url = `${this.getApiUrl('get_part_details')}/${jobId}`;
        let data = { 'partId': partId};
        return this.http.post(url, data);
    }

    getPricingItems():Observable<any>{
       let url =  this.getApiUrl(`system_settings/pricing_items`);
        return this.http.post(url, '');
    }

    getPartFormDetails(customerId:number,customerType:string,jobId:number): Observable<any> {
        let url = this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/parts/new`);
        return this.http.post(url, '');
    }

    getSupplierPrices(partId: number): Observable<any> {
        let url = this.getApiUrl (`parts_and_prices/${partId}/supplier_prices`);
        const supplierData = this.http.post<any>(url, '').pipe(
            map(response => {
                const processedData = (response.data || []).map((item: any) => ({
                    ...item,
                    priceupdatedon: item.priceupdatedon.split(' ')[0] || null
                }));

                return {
                    data: processedData,
                    count: processedData.length
                };
            })
        );
        return supplierData;
    }

    saveCreatedPart(data): Observable<any> {
        let url =  this.getApiUrl(`parts_and_prices/add`);
        return this.http.post(url, data);
    }

    getPartKitList(partId:number):Observable<any>{
        const url = `${this.getApiUrl('getPartKit')}`;
        const params = new HttpParams().set('partId', partId.toString());
        return this.http.get(url, { params });
    }

    savePartKit(customerId:number,customerType:string,jobId:number,partData):Observable<any>{
        let url = this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/add_part_kit`);
        let data = {
            data: JSON.stringify({
                part_kit: partData.kitId,
                part_kit_quantity: partData.setQuantity,
                part_status: partData.partStatus
            })
        };
        let headers = new HttpHeaders({'Content-Type': 'application/json'});
        return this.http.post(url, data, { headers }).pipe(
            tap(() => this.triggerFinanceRefresh(jobId))
        );
    }

    job_part_batch_status_update(jobId, activeTab, status, params: any) {
        if(activeTab == 'requested'){
            activeTab = 'Requested';
        }
        return this.http.post(this.getApiUrl(`jobs/${jobId}/parts/${activeTab}/part_batch_status_update/${status}`), params, {
            responseType: 'text'
        }).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );
    }

    jobPartPurchaseOrderDetail(partId:number,id:number,jobId:number,status:string){
        const url = this.getApiUrl('getJobPartViewList');
        const params = new HttpParams()
            .set('partId', partId.toString())
            .set('id', id.toString())
            .set('jobId', jobId.toString())
            .set('status', status);

        return this.http.get(url, { params });
    }

    saveEditPart(params):Observable<any>{
        const url = this.getApiUrl('edit_part');

        return this.http.post(url, params).pipe(
            tap(() => this.triggerFinanceRefresh(this.getJobIdFromPartPayload(params)))
        );
    }
    getUnApprovedLabourList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/forecasted/unapproved_labour`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getLabourRateBreakup(id: number): Observable<any> {
        const url = this.getJobApiUrl('getLabourRateBreakup/' + id);
        return this.http.get(url);
    }

    getPartsAvailableStockLocations(customerId: number, customerType: string, jobId: number, partsId: string): Observable<any> {
        let url = this.getJobApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/list_parts_stock_locations`);
        const params = new HttpParams().set('partId', partsId.toString());
        return this.http.get(url, { params });
    }

    getAllStockLocations(q){
        return this.http.get(this.getApiUrl(`get_all_stock_locations?q=${q}`));
    }

    getApprovedLabourList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/labour`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getApprovedTravelList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/travel`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    getApprovedPerDiemList = function (customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl((`customers/${customerType}/${customerId}/job/${jobId}/costs/actual_cost/per_diem`));
        if(param['download'] == 'download_xl'){
            return this.http.post(url, param, {responseType: 'blob'});
        }else {
            return this.http.post(url, param);
        }
    };

    saveFulfilSelectedParts(data: object):Observable<any>{
        return this.http.post(this.getApiUrl(`save_part_fulfill`), data).pipe(
            tap(() => {
                const payload: any = data as any;
                const refreshJobId = payload && (payload.jobId || payload.jobid);
                this.triggerFinanceRefresh(Number(refreshJobId || undefined));
            })
        );
    }

    askAIJobSummary(customerId, jobId, customerType, param) {
        let url = this.getJobApiUrl(`customers/${customerType}/${customerId}/job/${jobId}/ai-search-job`);
        return this.http.post(url, param); //
    }

    savePricingItem(customerId, jobId, customerType, data: FormData) {
        return this.http.post(this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/invoice_items/save`), data).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );
    }

    getTagList= function () {
        let url = this.getApiUrl(`tags/list?page=1&limit=100`);
        return this.http.get(url);
    };

    addLabourCosts(customerId, jobId, customerType, data: any): Observable<any> {
        let body = new URLSearchParams();

        // Set labourtype nested fields
        if (data.labourtype) {
            Object.keys(data.labourtype).forEach(key => {
                body.set(`labourtype[${key}]`, data.labourtype[key]);
            });
        }

        // Set other fields
        body.set('labourrate', data.labourrate || '');
        body.set('onsitetimehours', data.onsitetimehours || '0');
        body.set('onsitetimemins', data.onsitetimemins || '0');
        body.set('route', data.route || '');
        body.set('perdiem', data.perdiem || '');
        body.set('mileage', data.mileage || '');

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text' as 'json'
        };

        return this.http.post(
            this.getApiUrl(`customer/${customerType}/${customerId}/jobs/${jobId}/costs/labour/save_labour_cost`),
            body.toString(),
            options
        ).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );
    }

    saveEditLabour(customerId, jobId, customerType, data: any): Observable<any> {
        let body = new URLSearchParams();

        // Set labourtype nested fields
        if (data.labourtype) {
            Object.keys(data.labourtype).forEach(key => {
                // Handle objects (like diaryTimeTracking) by stringifying them
                const value = typeof data.labourtype[key] === 'object'
                    ? JSON.stringify(data.labourtype[key])
                    : data.labourtype[key];
                body.set(`labourtype[${key}]`, value !== null && value !== undefined ? value : '');
            });
        }

        if (data.labourItemId !== undefined) {
            body.set('labourItemId', data.labourItemId || '');
        }

        if (data.hasOwnProperty('isConnectedToDiaryEvent')) {
            body.set('isDisconnectedFromDiary', data.isConnectedToDiaryEvent === true ? '0' : '1');
        }

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        };

        return this.http.post(
            this.getApiUrl(`customer/${customerType}/${customerId}/jobs/${jobId}/costs/labour/update_labour_cost`),
            body.toString(),
            options
        ).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );

    }

    getEditLabourDetails(customerId: number, customerType: string, jobId: number, labourId: string, labourItemId?: string): Observable<any> {
        let url = this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/costs/${labourId}/labour_item_details`);
        if (labourItemId) {
            url += `?labourItemId=${labourItemId}`;
        }
        return this.http.get(url);
    }

    addTravelCosts(customerId, jobId, customerType, data: any): Observable<any> {
        let body = new URLSearchParams();
        body.set('travel[date]', data.date || '');
        body.set('travel[description]', data.description || '');
        body.set('travel[engineerid]', data.engineerid || '');
        body.set('travel[price]', data.price || '');
        body.set('route', 'jobs_v2');

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text' as 'json'
        };

        return this.http.post(
            this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/new_travel`),
            body.toString(),
            options
        ).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );
    }

    updateTravelCosts(customerId, jobId, customerType, data: any): Observable<any> {
        let body = new URLSearchParams();
        if (data.travel) {
            Object.keys(data.travel).forEach(key => {
                // Handle objects by stringifying them
                const value = typeof data.travel[key] === 'object'
                    ? JSON.stringify(data.travel[key])
                    : data.travel[key];
                body.set(`travel[${key}]`, value || '');
            });
        }

        let options = {
            headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded'),
            responseType: 'text' as 'json'
        };

        return this.http.post(
            this.getApiUrl(`update_travel`),
            body.toString(),
            options
        ).pipe(
            tap(() => this.triggerFinanceRefresh(Number(jobId)))
        );
    }

    getEditTravelDetails(customerId, jobId, customerType, travelId): Observable<any> {
        return this.http.get(
            this.getApiUrl(`customers/${customerType}/${customerId}/jobs/${jobId}/edit_travel/${travelId}/details`)
        );
    }

}
